<template>
  <div id="labelManage">
    <navBar/>
    <el-tabs v-model="activeName">
      <el-tab-pane label="盒标打印" name="labelPrint">
        <label-print :machineHandNoArray="machineHandNoArray" v-if="activeName === 'labelPrint'"/>
      </el-tab-pane>
      <el-tab-pane label="混标打印" name="mixedLabelPrint">
        <mixed-label-print :machineHandNoArray="machineHandNoArray" v-if="activeName === 'mixedLabelPrint'"/>
      </el-tab-pane>
      <el-tab-pane label="错标打印" name="errorLabel">
        <errorLabelPrintSX v-if="activeName === 'errorLabel'"
                           :machineHandNoArray="machineHandNoArray"/>
      </el-tab-pane>
      <el-tab-pane label="复制标签" name="labelCopy">
        <label-copy v-if="activeName === 'labelCopy'"/>
      </el-tab-pane>
      <el-tab-pane label="箱标打印" name="boxLabel">
        <boxLabelManage v-if="activeName === 'boxLabel'"/>
      </el-tab-pane>
	  <el-tab-pane label="发货拆箱" name="unPacking">
	    <un-packing v-if="activeName === 'unPacking'"/>
	  </el-tab-pane>
    <el-tab-pane label="发货并箱" name="combineBox">
        <combineBox v-if="activeName === 'combineBox'"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import labelPrint from './components/labelPrint';
  import mixedLabelPrint from './components/mixedLabelPrint';
  import labelCopy from './components/labelCopy';
  import unPacking from './components/unPacking';
  import boxLabelManage from './components/boxLabelManage';
  import combineBox from './components/combineBox';
  import errorLabelPrintSX from './components/errorLabelPrintSX';
  import navBar from './components/navBar';

  export default {
    components: {
      labelPrint,
      mixedLabelPrint,
      labelCopy,
      unPacking,
      boxLabelManage,
      combineBox,
      navBar,
      errorLabelPrintSX,
    },
    data() {
      return {
        activeName: 'labelPrint',
        machineHandNoArray: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
      }
    },
    mounted() {
      document.title = '标签打印';
    },
  };
</script>
<style lang="less" scoped>
  #labelManage {
    height: 100%;
    width: 100%;
    background: #0E1C3B;
  }

  .el-tabs {
    margin: 20px 8%;
  }

  /deep/ .el-tabs__item {
    color: white;
  }

  /deep/ .el-tabs__item.is-active {
    color: #409EFF;
  }

  /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
  }

  /deep/ .el-form-item__label {
    color: white !important;
  }

  /deep/ .el-input__inner {
    background: #0A1630;
    border: 1px solid #264791;
    color: white;
  }

  /deep/ .el-tabs__nav-scroll {
    overflow: hidden;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: center;
  }

  /deep/ .el-dialog {
    border: 1px solid #073E83;
  }

  /deep/ .el-dialog--center .el-dialog__body {
    background: #0E1C3B !important;
  }

  /deep/ .el-dialog__header {
    background: #0E1C3B !important;
  }

  /deep/ .el-dialog__title {
    color: white;
  }

  /deep/ .el-input-group__prepend {
    background: #0A1630;
    border: 1px solid #264791;
    color: white;
  }
</style>
<style lang="less" scoped>
  /deep/ .el-table {
    background: #0E1C3B;
  }

  /deep/ .el-table__empty-text {
    color: white;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    z-index: 11;
    width: 15px;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar:horizontal {
    height: 15px
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background: #253965;
    border-radius: 0;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:horizontal {
    background: #253965;
    border-radius: 0;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar-corner {
    background: #0e1c3b;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    background: #0e1c3b;
    border-radius: 0;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track-piece {
    background: #0e1c3b;
  }

  /deep/ .el-table td, .el-table th.is-leaf {
    border-bottom: 1px solid #073E83;
  }

  /deep/ .el-table__fixed-footer-wrapper tbody td {
    border-top: 1px solid #073E83;
  }

  /deep/ .el-table__fixed-right::before, .el-table__fixed::before {
    background: #073E83;
  }

  /deep/ .el-table__footer-wrapper td {
    border-top: none;
  }

  /deep/ .el-table th, .el-table tr {
    background-color: transparent;
  }

  /deep/ .el-table th.gutter {
    background-color: #0E1C3B !important;
    border: none;
    &:last-of-type {
      border-bottom: none !important;
    }
  }

  /deep/ .el-table th > .cell {
    white-space: normal !important;
  }

  /deep/ .el-table--border:after,
  /deep/ .el-table--group:after,
  /deep/ .el-table:before {
    background-color: #073E83;
  }

  /deep/ .el-table--border,
  /deep/ .el-table--group {
    border-color: #073E83;
  }

  /deep/ .el-table td,
  /deep/ .el-table th.is-leaf {
    border-bottom: 1px solid #073E83;
  }

  /deep/ .el-table--border th,
  /deep/ .el-table--border th.gutter:last-of-type {
    border-bottom: 1px solid #073E83;
  }

  /deep/ .el-table--border td,
  /deep/ .el-table--border th {
    border-right: 1px solid #073E83;
    background: #0E1C3B;
    &:hover {
      background: #0E1C3B !important;
    }
  }
  /deep/ .el-table__body-wrapper {
    z-index: 0;
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    background: #283654;
    border: 1px solid #264791;
    color: #909299;
  }
  /deep/ .el-button--primary {
    background: #1F76E3;
    border: 1px solid #1F76E3;
  }
  /deep/ .el-button--plain {
    background: transparent;
    border: 1px solid #153772;
    color: white;
  }
  /deep/ .el-button.is-disabled {
    background: #283654 !important;
    border: 1px solid #264791 !important;
    color: #909299 !important;
    &.el-button--text {
      background: transparent !important;
      border: none !important;
    }
  }
</style>
